export const VERSION = "1.0.46745"
export const BUILD_DATE = "Friday 06 May 2022 02:56:40 PM IST"
export const BUILD_TIMESTAMP = "1651829200"
